/**
 * Class for reading document wide scroll positions
 *
 * this class is usually used as a workaround for DOM els having position:fixed and any absolute positioned inner
 * child
 *
 * problem explanation:
 *  - some elements are positioned properly, if the document x scrollposition is 0.
 *    otherwise they are misaligned.
 *
 * examples:
 *  - div having display: fixed. any dom children is a vuetify dialog.
 *
 * https://github.com/vuetifyjs/vuetify/issues/12078
 */

class DocumentScrollService {

    readCurrentDocumentScrollXPosition() {
        let result = 0;
        if (document.scrollingElement) {
            result = document.scrollingElement.scrollLeft;
        }
        return result;
    }

    setDocumentScrollXPosition(targetXOffset: number) {
        if (document.scrollingElement) {
            document.scrollingElement.scrollLeft = targetXOffset;
        }
    }

}

const DOCUMENT_SCROLL_SERVICE_INSTANCE = new DocumentScrollService();

export {DOCUMENT_SCROLL_SERVICE_INSTANCE};
